import Rules from '@/services/validation/rules/rules'
export default {
  data() {
    return {
      driverRules: [
        v => Rules.isRequired(v),
      ],
      siteRules: [
        v => Rules.isRequired(v),
      ],
      vehicleRules: [
        v => Rules.isRequired(v),
      ],
      externalRefRules: [
        v => Rules.isRequired(v),
        v => Rules.minLength(v, 1),
        v => Rules.maxLength(v, 50),
      ],
      dateRules: [
        v => Rules.isRequired(v),
        v => Rules.isInValidDateRange(v)
      ],
      billingPeriodRules: [
        v => Rules.isRequired(v),
      ],
      notesRules: [
        v => Rules.minLength(v, 1),
        v => Rules.maxLength(v, 255)
      ],
    }
  }
}